/**
 * Settings Route
 *
 * Parent route for all settings pages
 */

import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/layout'

export const Route = createFileRoute('/settings')({
  component: SettingsLayout,
})

function SettingsLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
